module.exports = __webpack_public_path__ + "img/line-chart.f8f24a18.svg";